import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'not-authorized',
  templateUrl: './not-authorized.component.html',
  styleUrls: ['./not-authorized.component.scss']
})
export class NotAuthorizedComponent implements OnInit {

  /**
   * Email of the application administrator
   */
  @Input() adminEmail: string;

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    if(!this.adminEmail){
      //check for email supplied in route data
      if(this.route.snapshot.data && this.route.snapshot.data.adminEmail){
        this.adminEmail = this.route.snapshot.data.adminEmail;
      }
    }
  }

}
